import { gql } from "@apollo/client";
import { ApolloClientQuery } from "./_setup";

const GET_USER_PASSKEYS = gql`
    query getUserPasskeys {
        getUserPasskeys {
            ... on UserPasskeyArray {
                data {
                    _id
                    credentialId
                    deviceType
                    backedUp
                    name
                    lastUsedAt
                    createdAt
                }
                rpId
                userHandle
                enabled
                revokedCredentialIds
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getUserPasskeysQuery(fetchPolicy) {
    return await ApolloClientQuery(GET_USER_PASSKEYS, {}, false, fetchPolicy);
}

const START_PASSKEY_REGISTRATION = gql`
    mutation startPasskeyRegistration($input: PasskeyRegistrationInput) {
        startPasskeyRegistration(input: $input) {
            ... on PasskeyRegistrationOptions {
                options
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function startPasskeyRegistrationMutation(twoFactorChallengeId) {
    return await ApolloClientQuery(
        START_PASSKEY_REGISTRATION,
        { input: { twoFactorChallengeId } },
        true,
    );
}

const FINISH_PASSKEY_REGISTRATION = gql`
    mutation finishPasskeyRegistration($input: PasskeyRegistrationInput!) {
        finishPasskeyRegistration(input: $input) {
            ... on UserPasskey {
                _id
                credentialId
                deviceType
                backedUp
                name
                createdAt
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function finishPasskeyRegistrationMutation(response, name) {
    return await ApolloClientQuery(
        FINISH_PASSKEY_REGISTRATION,
        { input: { response: JSON.stringify(response), name } },
        true,
    );
}

const RENAME_USER_PASSKEY = gql`
    mutation renameUserPasskey($id: String!, $name: String!) {
        renameUserPasskey(id: $id, name: $name) {
            ... on UserPasskey {
                _id
                name
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function renameUserPasskeyMutation(id, name) {
    return await ApolloClientQuery(RENAME_USER_PASSKEY, { id, name }, true);
}

const REVOKE_USER_PASSKEY = gql`
    mutation revokeUserPasskey($id: String!, $twoFactorChallengeId: String) {
        revokeUserPasskey(id: $id, twoFactorChallengeId: $twoFactorChallengeId) {
            ... on UserPasskey {
                _id
                revokedAt
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function revokeUserPasskeyMutation(id, twoFactorChallengeId = null) {
    return await ApolloClientQuery(REVOKE_USER_PASSKEY, { id, twoFactorChallengeId }, true);
}
